import React from 'react'
import styled from 'styled-components'

const VideoWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 0;
  padding-bottom: 56.25%;

  & .video {
    object-fit: cover;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`

function EmbeddedYouTubeVideo({ youTubeLink }) {
  const match = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/.exec(
    youTubeLink
  )
  const youTubeId = match && match[7].length === 11 ? match[7] : null

  return (
    <VideoWrapper>
      <iframe
        className="video"
        title={`https://youtube.com/embed/${youTubeId}`}
        src={`https://youtube.com/embed/${youTubeId}`}
        allow="accelerometer; encrypted-media; gyroscope; picture-in-picture, controls"
        allowFullScreen
      />
    </VideoWrapper>
  )
}

export default EmbeddedYouTubeVideo
